import { ACTION } from './reducer';

const actions = {
  updateAllData({ reducerDispatch, data }) {
    reducerDispatch({
      type: ACTION.UPDATE_ALL_DATA,
      payload: {
        data,
      },
    });
  },

  updateResponseData({ reducerDispatch, responseData, isResponseSuccess = false }) {
    reducerDispatch({
      type: ACTION.UPDATE_RESPONSE_DATA,
      payload: {
        responseData,
        isResponseSuccess,
      },
    });
  },

  updateDisplayPaymentGateway({ reducerDispatch, displayPaymentGateway, isPremiumMidfunnelPayment = false }) {
    reducerDispatch({
      type: ACTION.UPDATE_DISPLAY_PAYMENT_GATEWAY,
      payload: {
        displayPaymentGateway,
        isPremiumMidfunnelPayment,
      },
    });
  },
  updateDisplayContext({ reducerDispatch, displayContext }) {
    reducerDispatch({
      type: ACTION.UPDATE_DISPLAY_CONTEXT,
      payload: {
        displayContext,
      },
    });
  },
};

export default actions;
